// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".editor__side-nav__primary{background-color:#fff;margin-bottom:1em;margin-top:1em}", "",{"version":3,"sources":["/quantu/app/javascript/components/application/layout/side-nav/styles/_primary.scss"],"names":[],"mappings":"AAGE,2BACE,qBAJS,CAKT,iBAAA,CACA,cAAA","file":"_primary.scss","sourcesContent":["$background: white !default;\n\n.editor__side-nav {\n  &__primary {\n    background-color: $background;\n    margin-bottom: 1em;\n    margin-top: 1em;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
